import { IState } from '../../../store';
import { TChartDataApiResponse } from '../types';

export const selectPriceHistoryChartData = (state: IState): TChartDataApiResponse => {
  return state.offerData.priceHistoryChartData;
};
